import { render, staticRenderFns } from "./BatchHeader.vue?vue&type=template&id=4179ded0&scoped=true&"
import script from "./BatchHeader.vue?vue&type=script&lang=js&"
export * from "./BatchHeader.vue?vue&type=script&lang=js&"
import style0 from "./BatchHeader.vue?vue&type=style&index=0&id=4179ded0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179ded0",
  null
  
)

export default component.exports